import { HPreparePropertyTitle } from "@rf-helper/property/prepare-title-property";
import { IPropertyDetailsResponse } from "@/src-refactor/modules/store/qrtk/services/realestate/responses/property-details.response";

export const prepareDetailPropertyName = (
  data: IPropertyDetailsResponse
): string => {
  return HPreparePropertyTitle({
    propertyType: data?.projecttype || data?.realstate_type,
    sectorName: data?.sector,
    cityName: data?.city,
    isProject: Boolean(data?.project_id)
  });
};
